<template>
  <div
    class="relative inline-block text-lg cursor-pointer group"
    @click.stop="share"
  >
  <span class="text-primary-700 group-hover:text-primary-600 group-hover:border-primary-600 border border-primary-700 rounded-full px-3 group-hover:px-4 py-1 transition-spacing duration-100"><span class="mr-2"><icon name="Share" /></span>{{ $t("general.share") }}</span>
    <div
      class="mt-2 bg-white p-6 shadow-lg group-hover:text-primary-900 grid gap-3 text-left"
      v-if="shareOpen"
    >
      <div class="grid grid-cols-1-auto mb-2">
        <p>{{ title }}</p>
        <div>
          <wd-button transparent @input="shareOpen = false"
            ><icon name="Close"
          /></wd-button>
        </div>
      </div>
      <div class="text-base text-gray-500 italic">
        {{ $t('news.share_link_info') }}
      </div>
      <div class="grid sm:grid-cols-1-auto gap-6">
        <div>
          <p class="text-sm font-mono">{{ url }}</p>
        </div>
        <div class="text-center">
          <wd-button @input="copy">{{ $t("general.copy") }}</wd-button>
        </div>
      </div>
      <div class="border-t border-gray-300 flex justify-around pt-6 mt-2">
        <a
          class="hover:text-primary-500"
          @click="setSent"
          :href="`mailto:?subject=${encodeURI(
            title
          )}+auf+STUPSI&body=Schau was ich gefunden hab:%0D%0A%0D%0A${encodeURI(
            title
          )}%0D%0A${encodeURI(url)}`"
          target="_blank"
          rel="noopener noreferrer"
          title="E-Mail"
          ><icon name="Mail" size="2.5em"
        /></a>
        <a
          class="hover:text-primary-500"
          @click="setSent"
          :href="`https://twitter.com/intent/tweet?text=${encodeURI(
            'Interessanter Artikel auf Stupsi.at: ' + title
          )}&url=${url}&hashtags=stupsi,power`"
          target="_blank"
          rel="noopener noreferrer"
          title="Twitter"
          ><icon name="Twitter" size="2.5em"
        /></a>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "ShareButton",
  data() {
    return {
      shareOpen: false,
    };
  },
  props: {
    title: {
      default: "",
      type: String,
    },
    url: {
      default: "",
      type: String,
    },
  },
  components: {},
  methods: {
    share() {
      if (navigator.share) {
        navigator
          .share({
            title: this.title,
            url: this.url,
          })
          .then(() => {
            this.setSent();
          })
          .catch(console.error);
      } else {
        this.shareOpen = !this.shareOpen;
      }
    },
    copy() {
      const el = document.createElement("textarea");
      el.value = `${this.url}`;
      el.setAttribute("readonly", "");
      el.style.position = "absolute";
      el.style.left = "-9999px";
      document.body.appendChild(el);
      const selected =
        document.getSelection().rangeCount > 0
          ? document.getSelection().getRangeAt(0)
          : false;
      el.select();
      document.execCommand("copy");
      document.body.removeChild(el);
      if (selected) {
        document.getSelection().removeAllRanges();
        document.getSelection().addRange(selected);
      }
      this.shareOpen = false;
      this.popup({
        type: "success",
        title: this.$t("news.link_copied_title"),
        text: this.$t("news.link_copied_text"),
      });
    },
    setSent(){
      this.shareOpen = false;
      this.popup({
              type: "success",
              title: this.$t("news.thanks_for_sharing_title"),
              text: this.$t("news.thanks_for_sharing_text"),
            });
    }
  },
  computed: {},
  created() {},
};
</script>
